import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
   
    container: {
       height: '60%',
       marginTop: '15%',
       textAlign: 'center',
    },

    icon:{
        color: 'red',
        fontSize: '5em',
    },
    permission:{
        fontSize: '1.15em',
    }
    
}));
